module.exports = __webpack_public_path__ + "stylesheets/title-shadow-block_2e8ab60e7c5d9e7779ce30b31b12c794.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/contest-landing/title-shadow-block.less
// module id = L2qt
// module chunks = 153